import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $showCompact: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    position: relative;
    z-index: 1;
    background: linear-gradient(0deg, rgba(21, 19, 39, 0) 0%, rgba(21, 19, 39, 1) 49%, rgba(21, 19, 39, 1) 100%);
    border-radius: 30px 30px 0 0;

    padding: 20px 20px 0 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 30px 25px 20px 30px;

        ${({ $showCompact }) =>
            $showCompact &&
            css`
                padding: 35px 0 0 0;
            `};
    }
`;

export const Collection = styled.div`
    overflow: hidden;
    padding-right: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const CollectionImage = styled.div<{ $image: string }>`
    border-radius: 4px;

    width: 24px;
    height: 24px;

    background-color: #000;
    flex-shrink: 0;

    ${({ $image }) => css`
        background-image: url(${$image});
        background-size: cover;
        background-position: center center;

        width: 30px;
        height: 30px;
    `};
`;

export const CollectionName = styled.div`
    font-family: 'Alliance No.1';
    font-weight: 700;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: -0.02em;
    text-transform: uppercase;

    color: #ffffff;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    flex-grow: 1;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 18px;
    }
`;

export const Controls = styled.div<{ $showCompact: boolean }>`
    display: none;
    gap: 10px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: flex;

        ${({ $showCompact }) =>
            $showCompact &&
            css`
                position: absolute;
                top: -13px;
                right: 16px;
            `};
    }
`;

export const MinimizeButton = styled.button`
    border: none;
    outline: none;

    border-radius: 100%;
    background: #2a2637;

    transition: background-color 200ms ease;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 30px;
    height: 30px;

    cursor: pointer;

    color: #fff;

    &:hover {
        background: #454055;
    }

    div {
        position: relative;
        top: 2px;
    }
`;
